import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthActions } from './auth.actions';
import { QueryParamsService } from '../../services';

@Injectable()
export class AuthEffects {
  private actions = inject(Actions);
  private queryParamsService = inject(QueryParamsService);

  initQueryParams$: Observable<Action> = createEffect(
    () =>
      this.actions.pipe(
        ofType(AuthActions.initQueryParams),
        switchMap(() => this.queryParamsService.getParams()),
        switchMap(queryParams => of(AuthActions.setQueryParams({ queryParams })))
      ),
    { dispatch: true }
  );

  setQueryParams$: Observable<Action> = createEffect(
    () =>
      this.actions.pipe(
        ofType(AuthActions.setQueryParams),
        switchMap(() => of(AuthActions.stopUpdate()))
      ),
    { dispatch: true }
  );
}
